import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

const defaultData: IDataLayer = {
  signin: {
    event_name: 'signin',
    event_category: 'account',
    event_action: 'login_success',
    event_noninteraction: 'false',
    event_label: null, // source: checkoutSignin/account/inStoreRamp/socialRamp
    account_referrer: null, // provider: email/facebook/line/rakuten/kakao/naver
    account_rememberme: null, // rememberMe: true/false
    account_source: null // source: checkoutSignin/account/inStoreRamp/socialRamp
  },

  signinFailed: {
    event_name: 'signin_fail',
    event_category: 'account',
    event_action: 'login_fail',
    event_noninteraction: 'false',
    event_label: null, // source: checkoutSignin/account/inStoreRamp/socialRamp
    account_referrer: null, // provider: email/facebook/line/rakuten/kakao/naver
    account_source: null // source: checkoutSignin/account/inStoreRamp/socialRamp
  },

  // TODO: this hasn't been updated in-line with the rest of the data in this file
  profileUpdate: {
    event_name: 'profile_update',
    event_category: 'account',
    event_action: 'profile update',
    event_value: '0',
    event_noninteraction: 'false',
    event_label: 'standard' // '<type of signin: standard or facebook'>
  },

  registrationFailed: {
    event_name: 'registration_fail',
    event_category: 'account',
    event_action: 'create_fail',
    event_noninteraction: 'false',
    event_label: null, // source: account/checkoutSignin/inStoreRamp/socialRamp
    account_referrer: null, // provider: email/facebook/line/rakuten/kakao/naver
    account_source: null, // source: account/checkoutSignin/inStoreRamp/socialRamp
    account_type: null // type: partial/complete
  },

  registration: {
    event_name: 'registration',
    event_category: 'account',
    event_action: 'create_success',
    event_noninteraction: 'false',
    event_label: null, // source: account/checkoutSignin/inStoreRamp/socialRamp
    account_referrer: null, // provider: email/facebook/line/rakuten/kakao/naver
    account_source: null, // source: account/checkoutSignin/inStoreRamp/socialRamp
    account_type: null // type: partial/complete
  }
};

function trackAccount(eventName: string, eventData: IDataLayer = {}) {
  eventData.account_referrer = eventData.account_referrer?.toLowerCase() || '';
  eventData.account_source = eventData.account_source?.toLowerCase() || '';
  eventData.event_label = eventData.account_source
    ? eventData.account_source
    : eventData.login_source?.toLowerCase() || '';
  eventData.ELC_USER_ID = eventData?.USER_ID;

  tealium.evtLink({ ...defaultData[eventName], ...eventData });
}

Object.keys(defaultData).forEach((key) => {
  registerAnalyticsEventHandler(key, trackAccount);
});
